export default "__VITE_ASSET__e70a4002__"